import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgAlertSuccess: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 102 102" {...props}>
    <g fillRule="nonzero" fill="none">
      <circle fill="#404040" cx={51} cy={51} r={51} />
      <path
        d="M36.5 61.44l33.17-29.87a5 5 0 017.06.37l.64.7a5 5 0 01-.4 7.1L43.13 69.58a4.65 4.65 0 01-6.92-.87l-.5-.74a5 5 0 01.78-6.53z"
        fill="#FFF"
      />
      <rect fill="#FFF" transform="rotate(-135 34.04 59.63)" x={20.54} y={54.13} width={27} height={11} rx={5} />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgAlertSuccess;
